// extracted by mini-css-extract-plugin
export default {"baseLink":"Mfnbj","disabled":"T6EOH"};